import shouldShowUnstackedReadingPane from 'owa-mail-organization-settings/lib/utils/shouldShowUnstackedReadingPane';

import {
    flaggedMailListItemColor,
    flaggedMailListItemColorDeprecated,
    expandedSelectedHeader,
    expandedMailListItemColor,
    selectedMailListItemColor,
    selectedMailListItemColorDeprecated,
    pinnedMailListItemColor,
    regularMailListItemColor,
} from 'owa-mail-listitem-styles/lib/scss/MailListItemBackgroundColors.scss';

export default function useBackgroundColorClass(
    isSelected: boolean,
    isFlagged: boolean,
    isPinned: boolean,
    isChecked: boolean,
    supportsFlagging: boolean,
    supportsPinning: boolean,
    isRowExpanded: boolean,
    numberOfSelectedItemParts: number | undefined,
    showFocusSelectStyles: boolean,
    isPendingSelection?: boolean
): string {
    const flaggedMailListItemColorClassName = showFocusSelectStyles
        ? flaggedMailListItemColor
        : flaggedMailListItemColorDeprecated;

    if (isSelected || isChecked || isPendingSelection) {
        const selectedMailListItemColorClassName = showFocusSelectStyles
            ? selectedMailListItemColor
            : selectedMailListItemColorDeprecated;

        const showOnlySubject = shouldShowUnstackedReadingPane() && isRowExpanded;
        if (showOnlySubject) {
            if (supportsFlagging && isFlagged) {
                return flaggedMailListItemColorClassName;
            }

            // There is never a scenario where numberOfSelectedItemParts is zero. To be cautious, I will wait until flight cleanup to remove it.
            const isHeaderSelected =
                !showFocusSelectStyles && isRowExpanded && numberOfSelectedItemParts == 0;
            return isHeaderSelected ? expandedSelectedHeader : expandedMailListItemColor;
        }

        // If row is expanded, then only apply selection UX if that row is also
        // checked. Otherwise, we want to show the expanded background color.
        if (isRowExpanded) {
            return isChecked
                ? selectedMailListItemColorClassName
                : !showFocusSelectStyles
                ? expandedMailListItemColor
                : '';
        }

        return selectedMailListItemColorClassName;
    } else if (supportsFlagging && isFlagged) {
        return flaggedMailListItemColorClassName;
    } else if (!showFocusSelectStyles && supportsPinning && isPinned) {
        return pinnedMailListItemColor; // no longer show background color for pinned items when focusselect flight is enabled
    } else {
        // no longer needed when focusselect flight is enabled. Base color class is applied directly in component.
        return showFocusSelectStyles ? '' : regularMailListItemColor;
    }
}
